<!-- Breadcrumbs -->
@if (shouldShowBreadcrumbs && breadcrumbsService.breadcrumbs$ | async; as breadcrumbs) {
    <div class="breadcrumb-section">
        <div class="breadcrumb-container">
            <ol class="breadcrumb">
                @for (breadcrumb of breadcrumbs; track breadcrumb; let i = $index) {
                    <li class="breadcrumb-item" [ngClass]="{ active: i === breadcrumbs.length - 1 }">
                        @if (breadcrumb.url && !(i === breadcrumbs.length - 1)) {
                            <a [routerLink]="breadcrumb.url">{{ breadcrumb.label }}</a>
                        }
                        @if (!breadcrumb.url || i === breadcrumbs.length - 1) {
                            <span>{{ breadcrumb.label }}</span>
                        }
                    </li>
                }
            </ol>
        </div>
    </div>
}
